export const environment = {
  base_url: 'https://sandbox.service.sanction.verifiedge.com',
  allowed_origin: 'https://sandbox.app.sanction.verifiedge.com',
  dataLimit: '20',
  production: false,
};
